export const Accounts = {
  REQUIRED_DOCUMENTS:
    "https://support.3et.com/support/solutions/articles/103000011870-what-documents-do-i-have-to-send-to-verify-my-account-",
  MINIMUN_DEPOSIT_REQUIREMENTS:
    "https://support.3et.com/support/solutions/articles/103000002166-minimum-deposit-requirement",
  DOCUMENTS_VERIFY_ACCOUNT:
    "https://support.3et.com/support/solutions/articles/103000011870-what-documents-do-i-have-to-send-to-verify-my-account-",
  TERMS_AND_CONDITIONS:
    "https://support.3et.com/support/solutions/articles/103000015424-terms-and-conditions",
  PRIVACY_POLICY:
    "https://support.3et.com/support/solutions/articles/103000015427-privacy-and-cookie-policies",
  MINIMUM_DEPOSIT:
    "https://support.3et.com/support/solutions/articles/103000002166-minimum-deposit-requirement",
  IDENTITY_DOCUMENTS:
    "https://support.3et.com/support/solutions/articles/103000011870-what-documents-do-i-have-to-send-to-verify-my-account-",
};
